import icon from "./chat-icon-color.svg";
import "./chat-icon.css";
const NewChatIcon = () => {
  return (
    <img
      src={icon}
      style={{
        scale: 1.7,
      }}
      className="ic d-flex scale-chat align-items-center justify-content-center"
    />
  );
};

export default NewChatIcon;
